import React, { useState } from "react";

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    setSending(true);

    const subject = form.subject ? `[Contact DOMOELEC] ${form.subject}` : '[Contact DOMOELEC] Nouveau message';
    const body = `Nom : ${form.name}\nEmail : ${form.email}\nTéléphone : ${form.phone || 'Non renseigné'}\nSujet : ${form.subject || 'Non renseigné'}\n\nMessage :\n${form.message}`;
    window.open(`mailto:contact@domoelec.ma?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`, '_blank');

    setForm({ name: '', email: '', phone: '', subject: '', message: '' });
    setSending(false);
  };

  return (
    <div className="ct-page">
      {/* Header */}
      <section className="ct-header">
        <div className="container">
          <span className="ct-label">Parlons de votre projet</span>
          <h1>Contactez-<span className="hdr-green">nous</span></h1>
          <p>Une question, un devis ou une demande d'information ? Nous sommes à votre écoute.</p>
        </div>
      </section>

      {/* Info cards */}
      <section className="ct-infos">
        <div className="container">
          <div className="ct-infos-grid">
            <a href="tel:0522340659" className="ct-info-item">
              <div className="ct-info-icon"><i className="fas fa-phone-volume"></i></div>
              <h4>Téléphone</h4>
              <p>05 22 34 06 59</p>
            </a>
            <a href="mailto:contact@domoelec.ma" className="ct-info-item">
              <div className="ct-info-icon"><i className="fas fa-envelope"></i></div>
              <h4>Email</h4>
              <p>contact@domoelec.ma</p>
            </a>
            <div className="ct-info-item">
              <div className="ct-info-icon"><i className="fas fa-map-marker-alt"></i></div>
              <h4>Siège</h4>
              <p>47 Rue Des Orangers, Ain Sebaa - Casablanca</p>
            </div>
            <div className="ct-info-item">
              <div className="ct-info-icon"><i className="fas fa-building"></i></div>
              <h4>Bureau</h4>
              <p>2ème étage, N° 16, 80 Bd Moulay Slimane, Casablanca 20250</p>
            </div>
            <div className="ct-info-item">
              <div className="ct-info-icon"><i className="fas fa-clock"></i></div>
              <h4>Horaires</h4>
              <p>Lun-Ven : 9h-18h / Sam : 9h-12h30</p>
            </div>
          </div>
        </div>
      </section>

      {/* Form + Map */}
      <section className="ct-main">
        <div className="container">
          <div className="ct-grid">
            {/* Formulaire */}
            <div className="ct-form-wrapper">
              <h2>Envoyez-nous un <span className="hdr-green">message</span></h2>
              <p className="ct-form-hint">
              </p>
              <form className="ct-form" onSubmit={handleSubmit}>
                <div className="ct-form-row">
                  <div className="ct-field">
                    <label>Nom *</label>
                    <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Votre nom complet" required />
                  </div>
                  <div className="ct-field">
                    <label>Email *</label>
                    <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="votre@email.com" required />
                  </div>
                </div>
                <div className="ct-form-row">
                  <div className="ct-field">
                    <label>Téléphone</label>
                    <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="06 XX XX XX XX" />
                  </div>
                  <div className="ct-field">
                    <label>Sujet</label>
                    <input type="text" name="subject" value={form.subject} onChange={handleChange} placeholder="Sujet de votre message" />
                  </div>
                </div>
                <div className="ct-field">
                  <label>Message *</label>
                  <textarea name="message" value={form.message} onChange={handleChange} rows="5" placeholder="Décrivez votre projet ou votre demande..." required></textarea>
                </div>
                <button type="submit" className="ct-submit" disabled={sending}>
                  <i className="far fa-paper-plane"></i> Envoyer le message
                </button>
              </form>
            </div>

            {/* Map */}
            <div className="ct-map-wrapper">
              <div className="ct-map">
                <iframe
                  title="DOMOELEC Localisation"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.0!2d-7.55!3d33.59!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDM1JzI0LjAiTiA3wrAzMycwMC4wIlc!5e0!3m2!1sfr!2sma!4v1!5m2!1sfr!2sma"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
